import {t} from '../../../common/getTranslations';
import {formatWithCommasAndDefaultHyphen} from '../../../common/shared/utils/formatWithCommasAndDefaultHyphen';
import {TableRow} from '../../../design-system/organisms/LinedTable/TableRow.interface';
import {GetRefundableAmountQuery} from '../../../graphql/generated/types';

export function createRefundableAmountTableRows(
  refundableAmount: GetRefundableAmountQuery['refundableAmount']
): TableRow[] {
  if (!refundableAmount) {
    return [];
  }
  return [
    {
      head: t('more_customer_cash_refund_realcash_amount'),
      cell: t('common_cash_amount', {
        values: {
          value: formatWithCommasAndDefaultHyphen(
            refundableAmount?.totalRemainAmount
          ),
        },
      }),
    },
    {
      head: t('more_customer_cash_refund_nonrefundable_amount'),
      cell: t('common_cash_amount', {
        values: {
          value: formatWithCommasAndDefaultHyphen(
            refundableAmount?.notRefundableAmount
          ),
        },
      }),
    },
    {
      head: t('more_customer_cash_refund_used_event_cash'),
      cell: t('common_cash_amount', {
        values: {
          value: formatWithCommasAndDefaultHyphen(
            refundableAmount?.usedEventCash
          ),
        },
      }),
    },
    {
      head: t('more_customer_cash_refund_commission'),
      cell: t('more_customer_cash_refund_amount_kr', {
        values: {
          value: formatWithCommasAndDefaultHyphen(refundableAmount?.refundFee),
        },
      }),
    },
  ];
}
